import { FormGroup } from '@angular/forms';
import { FormStructure, ServiceFilter } from '@common/components/export-to-pst/export-to-pst.model';
import { ExportToPSTFilter, ExportToPSTServices } from '@common/models';
import { isValidDate } from '@common/utils';
import { upperFirst } from 'lodash';

export class ExportToPstHelper {
  static GetServices(formGroup: FormGroup<FormStructure>): ExportToPSTServices[] {
    return Object.entries(formGroup.value)
      .filter(([, value]) => value?.checked)
      .map(([key, value]) => {
        return {
          Service: upperFirst(key),
          Filter: value?.filter ? this.GetFilterForService(value.filter as ServiceFilter) : null
        } as ExportToPSTServices;
      });
  }

  static GetFilterForService(filter: ServiceFilter): ExportToPSTFilter | null {
    if (!filter || !isValidDate(filter.from) || !isValidDate(filter.to)) return null;

    const from = new Date(filter.from);
    const to = new Date(filter.to);

    from.setHours(0, 0, 0, 0);
    to.setHours(23, 59, 59, 999);

    return {
      From: from.toISOString(),
      To: to.toISOString()
    };
  }

  static GetOneMonthAgoDate(): Date {
    const date = new Date();
    const monthAgo = date.getMonth() - 1;

    date.setMonth(monthAgo);

    return date;
  }
}
